import { WaterDrop } from "./water_drop";
import { Whatshot } from "./whatshot";
import { Work } from "./work";

const iconsList = [
  { label: "WaterDrop", code: <WaterDrop /> },
  { label: "Whatshot", code: <Whatshot /> },
  { label: "Work", code: <Work /> },
];

export {
  iconsList,
  WaterDrop,
  Whatshot,
  Work,
};
